module.exports = __webpack_public_path__ + "assets/485ffb2379669fefc310ed5328621382.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_500.mp3
 ** module id = 31
 ** module chunks = 0
 **/